module.exports = __webpack_public_path__ + "img/269.3951bd06.jpg";